<template>
  <v-text-field
    class="v-input__password"
    v-bind="computedProps"
    :append-icon="passwordVisible ? 'fal fa-eye' : 'fal fa-eye-slash'"
    :autocomplete="autocomplete"
    :outlined="outlined"
    :disabled="disabled"
    @click:append="passwordVisible = !passwordVisible"
    v-on="$listeners"
  />
</template>

<script lang="ts">
import Vue from 'vue'
import { VTextField } from 'vuetify/lib'

export default Vue.extend({
  name: 'PasswordField',
  extends: VTextField,
  props: {
    label: {
      type: String,
      default: 'Password'
    },
    autocomplete: {
      type: String,
      default: 'new-password'
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    passwordVisible: false
  }),

  computed: {
    computedProps: function (): object {
      return {
        ...this.$props,
        ...this.$attrs,
        type: this.passwordVisible ? 'text' : 'password'
      }
    }
  }

})
</script>

<style lang="scss">
.v-input__password {
  .v-icon {
    font-size: 16px;
  }
}
</style>
